import styled from '@emotion/styled';
import { typography } from '@landsbankinn/ui';
import React from 'react';
import { SliceWrapper } from './SliceWrapper';

interface IProps {
  children: React.ReactNode;
  copy: React.ReactNode;
  boxTitle: string | null;
  isArticle: boolean;
}

const Title = styled.h3`
  ${typography.bodyEditorial}
  font-weight: 500;
  margin-bottom: 15px;
`;

const List = styled.ul`
  li {
    margin-bottom: 5px;
  }
`;

export const TextWithLinks = ({
  children,
  copy,
  boxTitle,
  isArticle,
}: IProps) => {
  return (
    <SliceWrapper
      left={copy}
      right={
        <>
          <Title>{boxTitle}&#160;</Title>
          <List>{children}</List>
        </>
      }
      isArticle={isArticle}
    />
  );
};
